import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Casino Manage — owner-only switchboard for VIP / Virtual / Premium tables.
const casinoManageService = {
  list: async () => {
    const response = await api.get(API_ENDPOINTS.CASINO_MANAGE.LIST)
    return response.data
  },
  // enabled, min_balance, name, route, tile_category and img are writable;
  // game_type/category are identity and stay fixed.
  update: async (id, data) => {
    const response = await api.put(`${API_ENDPOINTS.CASINO_MANAGE.UPDATE}/${id}`, data)
    return response.data
  },
  create: async (data) => {
    const response = await api.post(API_ENDPOINTS.CASINO_MANAGE.CREATE, data)
    return response.data
  },
  // Multipart upload — the server (multer, memory) answers with a base64
  // dataUrl ready to preview and save onto a game row.
  uploadImage: async (file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(API_ENDPOINTS.CASINO_MANAGE.UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}

export default casinoManageService
